import { DisplayPosition } from '@/type/display-position';
// import { CnRating, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
import isPlainObject from 'lodash/isPlainObject';
import { transRequestConfigToRemote } from '@/common/manager/request';
import { getJSXTemplate, getMixedSetterSnippet, } from '@/common/manager/setter-snippet';
import { ButtonPosition } from '@/type/button-position';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '协议',
    componentName: 'CnAgreement',
    // component: CnRating,
    // formComponent: formComponentMap.CnRating,
    getFormItemDefaultProps: () => {
        return {};
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, _context } = config;
        const tempProps = formItem?.['x-component-props'];
        if (isPlainObject(tempProps)) {
            const { requestConfig } = tempProps;
            tempProps.requestCOnfig = transRequestConfigToRemote({
                requestConfig,
                state: _context?.state,
                isDesign,
            });
        }
    },
    getPrototypeList: () => {
        return [
            {
                name: 'labelText',
                title: '协议说明',
                display: 'inline',
                setter: getMixedSetterSnippet({
                    setters: [
                        {
                            componentName: 'CnI18nSetter',
                            title: '多语言设置器',
                        },
                        getJSXTemplate({
                            position: ButtonPosition.form,
                        }),
                    ],
                }),
            },
            //       {
            //         name: 'requestConfig',
            //         title: '协议内容请求',
            //         display: 'inline',
            //         setter: {
            //           componentName: 'ServiceChoiceSetter',
            //           props: {
            //             buttonText: '选择请求API',
            //             params: {
            //               env: 'pre',
            //               pageSize: 999,
            //               // serviceType: 'HSF',
            //             },
            //             paramTitleDom: <div className="">
            //               请求参数配置：
            //             </div>,
            //             // responseDom: <div style={{paddingTop:'10px'}}>
            //             //   请求返回结果的数据结构：<a target={'_blank'} href="https://yuque.antfin.com/docs/share/ae7a75a0-f1b1-48f4-82ac-8ea75e78f7f5#euKLg" rel="noreferrer">数据结构文档</a>
            //             // </div>,
            //             paramSetter: {
            //               componentName: 'MixedSetter',
            //               props: {
            //                 setters: [
            //                   {
            //                     componentName: 'ParamSelectSetter',
            //                     props: {
            //                       dataKey: 'config',
            //                       labelKey: 'label',
            //                       valueKey: 'name',
            //                       groupName: '参数列表',
            //                     },
            //                     title: '选择参数',
            //                   },
            //                   {
            //                     componentName: 'StringSetter',
            //                     title: '字符串',
            //                   },
            //                   getJSExpressionPrototype({
            //                     type:'base',
            //                   })
            //                 ],
            //               },
            //             },
            //             resultProcessFuncTemplate: `function(res) {
            //   // 需要返回的如下的数据结构
            //   // return {
            //   //   success: true,
            //   //   data: {
            //   //
            //   //   }
            //   // }
            //  return res;
            // }`,
            //           },
            //         },
            //       },
        ];
    },
};
